
export interface Country {
  id: number;
  code: string;
  name: string;
}
